import { QueryClient, useQuery } from "@tanstack/react-query";
import { API_ROUTES } from "definitions/constants/routeConstants";
import apiClient from "services/ApiClient";
import { apiMessageServiceChannelPathById } from "helpers/url/api/v2";
import { MessageServiceChannel } from "models/integration/messageService";

export const messagingChannelKeys = {
  all: ["messageServiceChannels"] as const,
  lists: () => [...messagingChannelKeys.all, "list"] as const,
  list: (filters: string) => [...messagingChannelKeys.lists(), { filters }] as const,
  details: () => [...messagingChannelKeys.all, "detail"] as const,
  detail: (id: string) => [...messagingChannelKeys.details(), id] as const,
};

export function setNewMessageServiceChannelInQueryClient(queryClient: QueryClient, messagingChannel: MessageServiceChannel) {
  queryClient.setQueryData(messagingChannelKeys.detail(messagingChannel.id), (oldData: MessageServiceChannel | undefined) => {
    if (!oldData) {
      return messagingChannel;
    }
    return {
      ...oldData,
      ...messagingChannel,
    };
  });
}

export const useMessageServiceChannelDetailQuery = (id: string, options: { enabled?: boolean } = {}) => useQuery<MessageServiceChannel>({
  queryKey: messagingChannelKeys.detail(id),
  staleTime: 1000 * 60 * 3, // 3 minutes
  queryFn: async () => apiClient.get<MessageServiceChannel>(apiMessageServiceChannelPathById(id)),
  ...options,
  enabled: options?.enabled !== undefined ? options.enabled && !!id : !!id,
});

export const useMessageServiceChannelListQuery = (queryString?: string, options: { enabled?: boolean } = {}) => useQuery<MessageServiceChannel[]>({
  queryKey: queryString ? messagingChannelKeys.list(queryString) : messagingChannelKeys.lists(),
  staleTime: 1000 * 60 * 3, // 3 minutes
  queryFn: async () => apiClient.get<MessageServiceChannel[]>(`${API_ROUTES.messageServices.channels.base}${queryString ? `?${queryString}` : ""}`),
  ...options,
});
